import { render, staticRenderFns } from "./platenoInput.vue?vue&type=template&id=2dc2d77e&scoped=true&"
import script from "./platenoInput.vue?vue&type=script&lang=js&"
export * from "./platenoInput.vue?vue&type=script&lang=js&"
import style0 from "./platenoInput.vue?vue&type=style&index=0&id=2dc2d77e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc2d77e",
  null
  
)

component.options.__file = "platenoInput.vue"
export default component.exports